<template>
  <div id="deposit">
    <!-- navbar -->
    <Navbar />
    <!-- local deposit -->
    <div class="local-depo mt-3" v-if="true">
      <h1 class="txt-title text-center fs-md-3 py-4">Deposit</h1>
      <div class="container mt-5">
        <div class="row">
          <!-- left side -->
          <div class="col-md-4 mb-4">
            <!-- select account -->
            <h3 class="txt-title fs-md-4 mb-4">
              Select Account
            </h3>
            <div class="select-account mb-4 d-flex flex-column align-items-start">
              <div class="select-custom mb-3">
                <select class="w-100" v-model="selectedAccount" name="select-account" id="select-account"
                  @change="onChangeAccount($event)" required :disabled="accountsLoading">
                  <option value="" disabled selected v-if="accountsLoading">
                    Loading accounts...
                  </option>
                  <option value="" disabled selected v-if="!accountsLoading">
                    Select your option
                  </option>
                  <option v-for="item in getAccount" :value="item._id" v-bind:key="item._id_num"
                    name="select-account-value" id="select-account-value">
                    {{ item.spec.name }} - {{ item.login_id }}
                  </option>
                </select>
                <span></span>
              </div>
              <!-- trading account information -->
              <div v-if="selected">
                <div v-for="item in getDataAccount" v-bind:key="item._id">
                  <div class="account-info p-0 m-0">
                    <div class="w-100 header-info">
                      <h4 class="text-center m-0 txt-title fs-md-5 fs-6">
                        Trading Account Information
                      </h4>
                    </div>
                    <div class="content-info fs-md-5">
                      <p>Account ID: {{ item.login_id }}</p>
                      <p>Account Type: REAL</p>
                      <p>Account Leverage: {{ item.leverage }}</p>
                      <p>Account Balance: $ {{ item.last_balance }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- right side -->
          <div class="col-md-8 right-side">
            <h2 class="txt-title fs-md-4 mb-4">
              Enter Deposit Amount
            </h2>
            <div class="bg_secondary p-4 rounded-primary">
              <div class="input">
                <label for="amount">
                  Amount in us dollars ($)
                </label>
                <div class="input-amount w-100">
                  <img src="/assets/img/dollar.svg" alt="" />
                  <input class="w-100" type="number" step="any" name="amount" id="amount" placeholder="0"
                    v-model.number="input_amount" required />
                </div>
              </div>
              <div class="input">
                <label for="nomor-akun"> Crypto address (*) </label>
                <input type="text" name="nomor-akun" id="nomor-akun" placeholder="Your wallet address"
                  v-model="crypto_address" required />
              </div>
              <div class="input">
                <label for="nomor-akun"> Crypto network (*) </label>
                <select v-model="crypto_network" name="" id="" class="select-bank form-control">
                  <option v-for="network in supportedNetworks" :key="network" :value="network">
                    {{ network }}
                  </option>
                </select>
              </div>
              <div class="input">
                <label for="email">
                  Registered Email
                </label>
                <input type="text" name="email" id="email" :value="email" readonly />
              </div>

              <p class="bg-light fs-md-7 py-3 px-4 mt-4 rounded"
                v-if="AppConstants?.deposit?.unique_code_disclaimer?.show"
                v-html="AppConstants.deposit.unique_code_disclaimer.html"></p>

              <div class="term-condition mb-4">
                <input type="checkbox" name="term" id="term" class="mr-3" required v-model="checked" value="checked" />
                <label for="term" class="txt-bold fs-md-7">
                  <p class="m-0">
                    I Agree With &nbsp;<a
                      href="https://secure.socrateslegacy.com/assets/legal/Socrates-Legal-Documents.pdf"
                      target="_blank">Terms and Conditions</a>
                  </p>
                </label>
              </div>
              <button class="btn btn-blue txt-bold" @click="confirmSubmit">
                Request Deposit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="belum-verifikasi" v-if="false">
      <div class="container mx-auto">
        <div class="row align-items-center justify-content-center wrap-verif">
          <div class="col-sm-5 col-12 flex-wrap order-2 order-sm-1">
            <p class="fs-sm-3 fs-4 txt-bold">Sorry,</p>
            <p class="fs-sm-4 fs-5">
              In order to make a Deposit, please verify the bank first formerly.
            </p>
            <a href="/verify-bank">
              <button class="btn btn-blue txt-bold rounded">
                Verification
              </button>
            </a>
          </div>
          <div class="img-wrapper col-sm-7 col-12 flex-wrap p-5 order-1 order-sm-2">
            <img src="/assets/img/verified-false.svg" class="p-sm-5 p-0" width="100%" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "../components/Navbar.vue";
import axios from "axios";
import Swal from "sweetalert2";
// Bank list replaced with hardcoded data
import Notiflix from "notiflix";
import { AppConstants } from "../const";
const userData = JSON.parse(localStorage.getItem("userData"));

const url = process.env.VUE_APP_API_URL;
const token = process.env.VUE_APP_API_TOKEN;
export default {
  name: "deposit",
  components: {
    Navbar,
  },
  data() {
    return {
      selectedAccount: "",
      selected: false,
      getAccount: [],
      getDataAccount: [],
      input_amount: null,
      input_final_amount: "",
      input_akun_pemilik: "",
      input_nomor_akun: "",
      selectBank: "",
      email: userData.user.email,
      rateUsd: 0,
      bank: "",
      checked: "",
      payment_id: "",
      getVerifBank: "",
      getLang: localStorage.getItem("setLang"),
      verified: true,
      crypto_address: null,
      crypto_network: "",
      accountsLoading: true,
      chargeAmount: "",
      chargePercent: "",
      unique_code: "",
      clickCount: 0,
      cooldown: 0,
      isCooldown: false,
      timer: null,
    };
  },
  computed: {
    supportedNetworks() {
      return AppConstants.crypto?.supportedNetworks || [];
    }
  },
  methods: {
    startCooldown() {
      this.isCooldown = true;
      this.cooldown = 60;

      this.timer = setInterval(() => {
        this.cooldown--;
        if (this.cooldown <= 0) {
          clearInterval(this.timer);
          this.resetCounter();
        }
      }, 1000);
    },
    resetCounter() {
      this.isCooldown = false;
      this.clickCount = 0;
    },
    onChangeAccount(e) {
      this.selected = true;
      this.selectedAccount = e.target.value;
      this.getDataAccount = this.getAccount.filter((data) => {
        if (data._id == e.target.value) {
          return data;
        } else {
          return null;
        }
      });
    },
    onChangeBank(e) {
      this.selectBank = e.target.value;
    },
    numberWithCommas: function (params) {
      return params.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    onSubmitDeposit() {
      Notiflix.Loading.circle({
        className: "notiflix-loading",
      });
      let self = this;

      var input_data_amount = this.input_final_amount || this.input_amount;

      const get_acc = self.getDataAccount[0];
      const hasCharge = AppConstants?.deposit?.charge?.enabled && self.chargeAmount > 0;
      const commentText = hasCharge
        ? `DEPOSIT - PLEASE CHANGE AMOUNT TO $${self.input_amount} ($${self.chargeAmount} from ${self.chargePercent}% fee and ${self.unique_code} unique code) <- DELETE THIS LATER`
        : `DEPOSIT - PLEASE CHANGE AMOUNT TO $${self.input_amount} (${self.unique_code} unique code) <- DELETE THIS LATER`;

      var data = {
        user_id: get_acc.user.id,
        user_name: get_acc.user.name,
        account_id: get_acc.id,
        account: get_acc.spec.name,
        login_id: get_acc.login_id,
        amount: `REQUEST: $${self.input_amount} | PAY: $${input_data_amount}`,
        bank_name: "[CRYPTO]",
        bank_acc: self.crypto_address,
        bank_username: "[CRYPTO]",
        app_env: process.env.VUE_APP_MODE,
        deposit_id: input_data_amount,
        comment: commentText,
      };
      console.debug("data_local :", data);
      var data_orbit = {
        account_id: self.getDataAccount[0]._id,
        user_id: self.getDataAccount[0].user_id,
        amount: Number(input_data_amount),
        method: "CRYPTO",
        type: "DEPOSIT",
        crypto_address: this.crypto_address,
        crypto_type: this.crypto_network,
        comment: commentText,
      };
      console.debug("data_orbit", data_orbit);
      var config = {
        method: "post",
        url: `${url}/payment/deposit`,
        headers: {
          "content-type": "application/json",
          "x-app-token": token,
          "x-user-token": userData.token,
        },
        data: data_orbit,
      };

      var gethistorypaymentfromApi = {
        method: "get",
        url: `${url}/me/payments`,
        headers: {
          "content-type": "application/json",
          "x-app-token": token,
          "x-user-token": userData.token,
        },
      };

      axios(config)
        .then(function (res) {
          const dataDeposit = res.data.data.payment;
          self.payment_id = dataDeposit._id;
          Notiflix.Loading.remove();

          axios(gethistorypaymentfromApi)
            .then(function (res) {
              let obj = res.data.data.payment.slice(-1)[0];
              // const obj = res.data.data.payment.forEach((item)=>{
              //   if(item._id === self.payment_id){
              //     return item
              //   }
              // })
              // console.log("obj: ", obj);
              const login_id = self.getDataAccount[0].login_id;
              localStorage.setItem("historyPaymentID", JSON.stringify(obj));
              localStorage.setItem("login_id", JSON.stringify(login_id));
              localStorage.setItem(
                "saved_wallet",
                "[" + self.crypto_network + "] " + obj.crypto.crypto_address
              );
              // console.log("saved_wallet: ", self.crypto_address);
              // console.log("itemmmmm: ", res.data.data.payment);
              window.location.href = "/verify-time";
            })
            .catch(function (error) {
              console.log(error);
            });

          Swal.fire({
            icon: "success",
            title: "You Successfully Request Deposit",
            showConfirmButton: false,
            timer: 3000,
          });
          console.log("data depo: ", self.payment_id);
        })
        .catch(function (error) {
          self.clickCount = 0; // Reset on error
          if (error.response.status == 500) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message,
            });
          }
          console.log(error);
        });


    },
    confirmSubmit() {
      // Check cooldown first
      if (this.isCooldown) {
        Swal.fire({
          title: "Cooldown",
          text: `Please wait ${this.cooldown} seconds before making another request.`,
          icon: "warning",
        });
        return;
      }

      if (
        !this.checked ||
        !this.selected ||
        !this.input_amount ||
        !this.crypto_address
      ) {
        Swal.fire({
          icon: "question",
          title: "Incomplete Data!",
          text: "Complete your data to request deposit!",
          confirmButtonText: "OK",
        });
      } else {
        // Increment click count
        this.clickCount++;

        // If more than 4 attempts, start cooldown
        if (this.clickCount > 4) {
          this.startCooldown();
          return;
        }

        var amount_with_charge = this.input_amount;
        var charge_percent = 0;
        var charge_amount = 0;

        // Generate 2 digit random unique code
        let randomNumber = (Math.random() * (0.30 - 0.01) + 0.01).toFixed(2);
        this.unique_code = Number(randomNumber);

        if (AppConstants?.deposit?.charge?.enabled) {
          const chargeConfig = AppConstants.deposit.charge.value;

          const chargeEntry = chargeConfig
            .filter(charge => this.input_amount < charge.amount_max)
            .sort((a, b) => a.amount_max - b.amount_max)
            .find(() => true);

          charge_percent = chargeEntry?.percent ?? 0;
          charge_amount = Math.floor((Number(this.input_amount) * charge_percent) / 100 * 1000) / 1000;
          amount_with_charge = Number((Number(this.input_amount) + Number(charge_amount) + Number(this.unique_code)).toFixed(2));
        } else {
          amount_with_charge = Number((Number(this.input_amount) + Number(this.unique_code)).toFixed(2));
        }

        Swal.fire({
          title: "Are You Confident With Your Data?",
          html: `
            <br/><b>Login ID</b>: ${this.getDataAccount[0].login_id}
            <br/><b>Request Amount</b>: USDT ${this.input_amount}
            <br/><b>Crypto Fee</b>: USDT ${charge_amount} (${charge_percent}% fee)
            <br/><b>Unique Code</b>: USDT +${this.unique_code}
            <br/><b>Total Transfer</b>: USDT ${amount_with_charge.toFixed(2)}
            `,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            this.chargeAmount = charge_amount;
            this.chargePercent = charge_percent;
            this.input_final_amount = amount_with_charge;
            this.onSubmitDeposit();
          }
        });
      }
    },
  },
  created() {
    localStorage.setItem("pageNow", "deposit");
  },
  mounted() {
    Notiflix.Loading.init({
      className: "notiflix-loading",
      zindex: 4000,
      backgroundColor: "rgba(0,0,0,0.8)",
      rtl: false,
      useGoogleFont: false,
      fontFamily: "Quicksand",
      cssAnimation: true,
      cssAnimationDuration: 400,
      clickToClose: false,
      customSvgUrl: null,
      svgSize: "80px",
      svgColor: "#c09a07",
      messageID: "NotiflixLoadingMessage",
      messageFontSize: "15px",
      messageMaxLength: 34,
      messageColor: "#dcdcdc",
    });
    window.scrollTo(0, 0);



    // Validate crypto configuration exists
    if (!AppConstants.crypto) {
      console.error("CRITICAL: Crypto configuration missing for current grey label");
      Notiflix.Notify.failure("Crypto configuration not found for this platform");
      return;
    }

    Notiflix.Loading.circle();
    var checkStatusUser = {
      method: "get",
      url: `${url}/me`,
      headers: {
        "content-type": "application/json",
        "x-app-token": token,
        "x-user-token": userData.token,
      },
    };
    axios(checkStatusUser)
      .then(function () {
        Notiflix.Loading.remove();
      })
      .catch(function (error) {
        console.error("Auth check failed:", error);
        Notiflix.Loading.remove();
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
      });

    // Set default crypto network to first supported network
    if (this.supportedNetworks.length > 0) {
      this.crypto_network = this.supportedNetworks[0];
    } else {
      console.error("CRITICAL: No supported crypto networks found");
      Notiflix.Notify.failure("No crypto networks available for this platform");
    }
    var config = {
      method: "get",
      url: `${url}/me/accounts`,
      headers: {
        "content-type": "application/json",
        "x-app-token": token,
        "x-user-token": userData.token,
      },
    };
    let self = this;
    axios(config)
      .then(function (res) {
        let obj = res.data.data.account;
        self.getAccount = obj.filter((item) => {
          if (item.login_id && item.status === "ACTIVE" && item.type === "REAL") {
            return item;
          } else {
            return null;
          }
        });
        console.log(self.getAccount);
        self.accountsLoading = false;
      })
      .catch(function (error) {
        console.log(error);
        self.accountsLoading = false;
      });
    // Static rate - replace with your preferred rate source
    self.rateUsd = 15000; // Manual rate fallback
    //
    var verifBank = {
      method: "get",
      url: `${url}/me/verifications?category=PAYMENT&sort[created_at]=desc`,
      headers: {
        "content-type": "application/json",
        "x-app-token": token,
        "x-user-token": userData.token,
      },
    };
    axios(verifBank)
      .then(function (res) {
        let obj = res.data.data.verification.reverse();

        obj.forEach(function (item) {
          if (item.status == "SUCCESS") {
            const getdatabank = item.bank;
            const dataBank = {
              bank_name: getdatabank.bank_name,
              bank_acc: getdatabank.bank_acc,
              bank_username: getdatabank.bank_username,
            };
            self.input_akun_pemilik = getdatabank.bank_username;
            self.input_nomor_akun = getdatabank.bank_acc;
            self.selectBank = getdatabank.bank_name;
            self.input_bank_name = getdatabank.bank_name;
            localStorage.setItem("databank", dataBank);
            self.getVerifBank = "active";
            self.verified = true;
            localStorage.setItem("verifbank", true);
          } else if (self.getVerifBank != "active") {
            self.getVerifBank = "false";
            self.verified = false;
            localStorage.setItem("verifbank", false);
          }
          console.log("verifBank:", localStorage.getItem("verifbank"));
        });
      })
      .catch(function (error) {
        self.verified = false;
        console.log(error);
      });
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>